var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyFolder = function SvgEmptyFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8F94B2",
    d: "M37.11 11.03h-.796v-.354c0-1.743-1.418-3.161-3.162-3.161H18.405c-.465 0-1.138-.431-1.334-.853L15.405 3.05c-.64-1.384-2.27-2.428-3.794-2.428H3.94C2.197.622.779 2.041.779 3.784v26.46c0 1.744 1.418 3.163 3.162 3.163h4.287c.06.003.116.018.176.018h18.55v-2.71H8.404c-.059 0-.09-.009-.11-.018l-.024-.013c-.007-.008-.021-.05-.006-.136l3.06-16.136c.064-.34.467-.673.81-.673h24.977c.088 0 .128.023.133.031.006.008.022.05.006.137l-.936 4.937-2.123 11.197c-.064.34-.467.673-.812.673h-3.592v2.71h3.592c1.642 0 3.169-1.264 3.475-2.878l3.059-16.135c.164-.864-.048-1.728-.581-2.37-.533-.642-1.342-1.012-2.221-1.012zm-3.506 0H12.136c-1.642 0-3.168 1.263-3.475 2.877L5.602 30.043c-.042.22-.058.438-.052.654H3.94c-.244 0-.45-.207-.45-.452V3.784c0-.245.206-.452.45-.452h7.67c.466 0 1.139.431 1.334.853l1.667 3.612c.64 1.384 2.27 2.428 3.794 2.428h14.747c.245 0 .452.206.452.451v.353z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-folder.6167cce3.svg";
export { ForwardRef as ReactComponent };